import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Button from '@trileuco/triskel-react-ui/components/ui/Button'
import {
  MessageProvider,
  useIntl
} from '@trileuco/triskel-react-ui/components/i18n'
import { useGetBookable, LoadingResults } from 'components/api'
import { useGenerateBookablePath } from 'modules/bookables/routes'
import BookableDetailsContent from 'modules/bookables/pages/bookableDetails/BookableDetailsContent'
import NotFoundError from 'components/error/NotFoundError'

const PreviewWidget = ({ id, referrer }) => {
  const { msg } = useIntl({
    scope: 'bookableDetailsPage'
  })
  const generateBookablePath = useGenerateBookablePath()
  const { bookable, loading } = useGetBookable({ bookableId: id })
  const handleClick = useCallback(() => {
    const bookableUrl = `${generateBookablePath(bookable)}?referrer=${referrer}`
    window.open(bookableUrl, '_blank')
  }, [referrer, bookable, generateBookablePath])

  if (loading) {
    return <LoadingResults />
  }
  if (!bookable) {
    throw new NotFoundError('Bookable not found for id ' + id)
  }
  return (
    <MessageProvider scope="bookableDetailsPage">
      <BookableDetailsContent bookable={bookable} />
      <Button text={msg({ id: 'bookNow' })} onClick={handleClick} />
    </MessageProvider>
  )
}

PreviewWidget.propTypes = {
  id: PropTypes.string,
  host: PropTypes.string,
  referrer: PropTypes.string
}

PreviewWidget.displayName = 'PreviewWidget'

export default PreviewWidget
